export const reviewStyles = {
  iconLabel: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  color: '#FFFFFF',
  backgroundColor: '#676767',
  width: '12.5rem',
  padding: '0.5rem 0.25rem',
  borderRadius: '4px',
  },

  iconText: {
    marginBottom: '0.125rem',
    fontSize: '1.2rem',
  },
  gappedItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
  },
  largeGap: {
    gap: '3rem',
  },
}


